import styled from 'styled-components';
import { useModal } from "../../hooks/modalContext";

import CheckListAdd from "../../components/client/CheckListAdd";

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

import {useEffect, useState} from "react";
import {confirmAlert} from "react-confirm-alert";

export default function CheckListManage() {
  //공통
  const [isSubmit, setIsSubmit] = useState(false);

  //고객사 선택 키 값
  const [clientKey, setClientKey] = useState({
    custMstSeq: '',
    clientName: '',
  });
  //체크리스트 추가
  const { openModal } = useModal();
  const handleAdd = () => {
    if(clientKey === '') {
      Common.errorMsg('고객사를 선택해주세요.');
      return;
    }

    openModal({
      modalName: 'CheckListAdd',
      modalData: {
        isRegi: true,
        data: {
          item: {
            clientKey: clientKey
          },
          callback: getClientCheckList,
        },
      }
    });
  };

  //고객사 리스트
  const [clientList, setClientList] = useState([]);
  const getClientList = () => {
    Server.sendGet('client/select', {}, getClientListCallback).then();
  }
  const getClientListCallback = res => {
    setClientList(res['resultList']);
  }
  const clientClick = item => {
    setClientKey(() => {
      return {
        ...clientKey,
        custMstSeq: item.custMstSeq,
        clientName: item.custName
      }
    });
    getClientCheckList(item.custMstSeq);
  }
  useEffect(() => {
    getClientList();
  },[]);

  //고객사 체크리스트
  const [clientCheckList, setClientCheckList] = useState([]);
  const getClientCheckList = custMstSeq => {
    Server.sendGet(
      'client/check/list',
      {
        custMstSeq: custMstSeq,
      },
      getClientCheckListCallback
    )
  }
  const getClientCheckListCallback = res => {
    setClientCheckList(res['resultList']);
  }

  //체크리스트 삭제
  const deleteClientCheckList = seq => {
    if(!isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to delete?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            Server.sendPatch(
              'client/check/list',
              {
                seq: seq
              },
              deleteClientCheckListCallback
            ).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  }

  const deleteClientCheckListCallback = res => {
    setIsSubmit(false);
    Common.alertSuccess();
    getClientCheckList(clientKey.custMstSeq);
  }

  return (
    <ContentWrap>
      <div className='content-inner'>
        {/* 타이틀 */}
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>CheckList Management</h4>
          </div>
        </div>
        {/* 컨텐츠 */}
        <div className='content'>
          <div className='util-button'>
            <button
              className='util-btn primary'
              onClick={handleAdd}
            >Add</button>
          </div>
          <div className='table-wrap'>
            <div className='client-table'>
              <table>
                <thead>
                <tr>
                  <th>No</th>
                  <th>Client</th>
                </tr>
                </thead>
                <tbody>
                {/* Map 반복 지점 */}
                {clientList?.map((item, idx) => (
                  <tr
                    key={item.custMstSeq} onClick={() => clientClick(item)}
                    className={clientKey.custMstSeq === item.custMstSeq ? "selected" : ""}
                  >
                    <td>{idx + 1}</td>
                    <td>{item.custName}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
            <div className='manage-table'>
              <table>
                <colgroup>
                  <col width='40%' />
                  <col width='40%' />
                  <col width='20%' />
                </colgroup>
                <thead>
                <tr>
                  <th>Work</th>
                  <th>QR Code</th>
                  <th>Delete</th>
                </tr>
                </thead>
                <tbody>
                {/* Map 반복 지점 */}
                {clientCheckList?.map((item, idx) => (
                  <tr>
                    <td>{item.checkName}</td>
                    <td>{item.qrCodeName}</td>
                    <td>
                      <button
                        className='delete-btn'
                        onClick={() => deleteClientCheckList(item.seq)}
                      >Delete</button>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
          {/*<div className='pagination'>*/}
          {/*  <button><img src='https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/chevron-double-left.webp'*/}
          {/*               alt='first'/></button>*/}
          {/*  <button><img src='https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/chevron-left.webp' alt='prev'/>*/}
          {/*  </button>*/}
          {/*  <ul>*/}
          {/*    /!* 선택된 pagination이면 li에 className='selected' 부여 *!/*/}
          {/*    <li>*/}
          {/*      <span>1</span>*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*  <button><img src='https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/chevron-right.webp' alt='next'/>*/}
          {/*  </button>*/}
          {/*  <button><img src='https://ust-erp.s3.ap-northeast-2.amazonaws.com/icon/chevron-double-right.webp'*/}
          {/*               alt='end'/></button>*/}
          {/*</div>*/}
        </div>
      </div>
    </ContentWrap>
  )
}

const ContentWrap = styled.div`
  position:relative;
  flex:1;
  background:#fff;
  font-family: 'Apple SD Gothic Neo', sans-serif;

  .content-inner {
    position:relative;

    .content {
      height: auto !important;

      .util-button {
        position:relative;
        display:flex;
        justify-content: flex-end;
        align-items:center;
        gap:0 10px;

        .util-btn {
          padding:0 20px;
          height:40px;
          line-height:40px;
          font-weight:600;
          font-size:14px;
          color:#ffffff;
          background:#a5a5a5;
          border-radius:4px;

          &.primary {
            background:#056eae;
          }
        }
      }

      .table-wrap {
        margin-top:30px;
        position:relative;
        display:flex;
        gap:0 100px;

        .client-table {
          position:relative;
          width:480px;

          table tr td:last-child {
            cursor:pointer;
          }
        }

        .manage-table {
          position:relative;
          flex:1;
          max-height:599px;
          overflow-y:auto;

          table thead {
            position:sticky;
            top:0;
            left:0;
          }
        }

        table {
          position:relative;
          border-collapse:separate;
          border-spacing:0;
          border-bottom:1px solid #111111;

          .selected td {
            background:#dddddd;
          }

          th {
            padding:15px 0;
            background:#eaeaea;
            font-weight:500;
            font-size:16px;
            border-top:1px solid #717171;
            border-bottom:1px solid #717171;
            color:#111111;
          =          }

          td {
            padding:15px 0;
            font-weight:500;
            font-size:14px;
            color:#111111;
            text-align:center;
            vertical-align: middle;
            height:60px;

            button {
              padding:0 10px;
              height:30px;
              line-height:30px;
              font-size:14px;
              font-weight:400;
              color:#ffffff;
              background:#bcbcbc;
              border-radius:4px;
            }
          }

          tr + tr td {
            border-top:1px solid #dddddd;
          }
        }
      }
    }
  }
`


